module.exports = __webpack_public_path__ + "img/maPread_icon_color.83acab28.svg";